import {useSelector} from 'react-redux'
import {getHasInAppFirstSignal} from 'modules/search/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

/**
 * InAppFirst mode is active when the brand is eligible
 * (`shell.supportsInAppFirst`, consumed through the capability framework) AND
 * the session signal is present (the `inAppFirst=1` URL param or the persisted
 * sticky flag). The capability gate keeps the mode Kiwi-only — the param alone
 * cannot activate it on other brands.
 */
export const useInAppFirst = () => {
  const {shell} = useBrandCapabilities()
  const hasSignal = useSelector(getHasInAppFirstSignal)

  return {
    isInAppFirst: shell.supportsInAppFirst && hasSignal
  }
}
